import { useEffect } from "react";

interface SEOHeadProps {
  structuredData?: Record<string, unknown>;
}

export default function SEOHead({ structuredData }: SEOHeadProps) {
  useEffect(() => {
    if (!structuredData) return;

    const scriptEl = document.createElement("script");
    scriptEl.type = "application/ld+json";
    scriptEl.textContent = JSON.stringify(structuredData);
    scriptEl.setAttribute("data-readdy-schema", "true");
    document.head.appendChild(scriptEl);

    return () => {
      if (scriptEl.parentNode) {
        document.head.removeChild(scriptEl);
      }
    };
  }, [structuredData]);

  return null;
}